const leftDefaultLenAddress = 5;
const rightDefaultLenAddress = 3;

/**
 * Сжимает адрес, оставляя указанные количество символов
 * слева и справа, а также добавляет многоточие между ними.
 *
 * @param {string} address - Адрес, который нужно сжать.
 * @param {Object} [options] - Опции для настройки длины отрезков.
 * @param {number} [options.leftLen=6] - Количество символов, которые нужно оставить слева.
 * @param {number} [options.rightLen=6] - Количество символов, которые нужно оставить справа.
 * @returns {string} - Сжатый адрес или исходное значение, если адрес не соответствует формату.
 */
export const formatAddress = (
  address: string,
  options?: { leftLen?: number; rightLen?: number }
): string => {
  if (!address) {
    return '';
  }

  const leftLen = options?.leftLen ?? leftDefaultLenAddress;
  const rightLen = options?.rightLen ?? rightDefaultLenAddress;

  if (leftLen < 0 || rightLen < 0) {
    return address;
  }

  if (rightLen > leftLen) {
    return address;
  }

  return `${address.slice(0, leftLen)}...${address.slice(-rightLen)}`;
};
